export default "__VITE_ASSET__DE1J_2kJ__"